import { Constants } from "@constants";
import apiService, { requestInterceptorsHandler } from "@utils/apiService";
import { deleteAuthorizationToken, queryStringToObject } from "@utils/helper";
// eslint-disable-next-line import/no-unresolved
import { updateStateSubject } from "@gartner/genie-messenger-util";

const autoLogout = () => {
  localStorage.setItem(Constants.LOGOUT_EVENT_KEY, false);

  window.addEventListener('storage', (event) => {
    if (event.key === Constants.LOGOUT_EVENT_KEY && event.newValue === 'true') {
      logout();
    }
  });
};

export function redirectToLogin() {
  const origin = window.location.origin;
  let redirectToLogin = `${Constants.API.API_PATH_TOOLS}${Constants.API.LOGIN}`;
  if (origin.indexOf("developer.gartner.com") !== -1) {
    redirectToLogin = `${Constants.ROUTES.GENIE_AUTH_URL}`;
  }
  redirectToLogin += `?TARGET=${encodeURIComponent(origin)}${Constants.ROUTES.BASE_URL
    }`;
  redirectToLogin += Constants.ROUTES.GENIE_AUTH_PARAMS;
  deleteAuthorizationToken(Constants.GENIE_ACCESS_CODE);
  localStorage.setItem(Constants.LOGOUT_EVENT_KEY, 'true');
  window.location.replace(redirectToLogin);
}

export function login(eventData) {
  const { status, data } = eventData;
  if (status === 200) {
    updateStateSubject("login", {
      ...data,
      statusCode: status,
    });
    autoLogout();
  } else {
    const { login: loginFromUrl = false } = queryStringToObject(
      window?.location?.search
    );
    if (!loginFromUrl) {
      deleteAuthorizationToken(Constants.GENIE_ACCESS_CODE);
      requestInterceptorsHandler({});
    } else {
      updateStateSubject("login", {
        statusCode: 10000,
      });
    }
  }
}

export function logout() {
  apiService(`${Constants.API.API_PATH_GCOM}`)
    .post(
      `${Constants.API.LOGOUT}`,
      {},
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          withCredentials: true,
        },
      }
    )
    .catch(() => {})
    .finally(() => {
      redirectToLogin();
    });
}
